import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { useGetProductsMutation } from "../../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../../features/auth/authSlice";
import { Button, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Slider from "react-carousel-responsive";
import "react-carousel-responsive/dist/styles.css";
import EditProductModal from "../../models/EditProductModal";

const Index = () => {
  const [getproductsAPI] = useGetProductsMutation();
  const [products, setProducts] = useState([] as any);
  const sponserId = useSelector(selectSponserID);
  const location = useLocation();
  const props = location.state;
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({} as any);

  useEffect(() => {
    const getproducts = async () => {
      const response: any = await getproductsAPI({
        sponserId,
        landingPageId: props._id,
      }).unwrap();
      if (response.status === 200) {
        setProducts(response.products);
      }
    };
    getproducts();
  }, [getproductsAPI, props._id, sponserId]);

  return (
    <div className="ml-5 mt-[100px]">
      <Header title="Products" subtitle="View Products" />
      {products?.map((product: any) => {
        return (
          <div key={product?._id} className="w-[500px]">
            <div className="flex justify-center">
              <Typography variant="h4">{product?.title}</Typography>
            </div>
            <div className="z-[0] relative">
              <Slider>
                {product?.imgUrls?.map((image: string, i: number) => {
                  return (
                    <div className="slide">
                      <img
                        height={"500px"}
                        width={"500px"}
                        src={process.env.REACT_APP_BACKEND_API + "/" + image}
                        alt="product"
                        key={i}
                      />
                    </div>
                  );
                })}
              </Slider>
            </div>
            <div>{product?.description}</div>
            <div className="flex justify-between">
              <div>Price: {product?.price + "Rs/-"}</div>
              <div>Quantity: {product?.quantity}</div>
            </div>
            <Button
              variant="contained"
              onClick={() => {
                setEditData({
                  price: product?.price,
                  quantity: product?.quantity,
                  description: product?.description,
                  imageUrls: product?.imageUrls,
                  title: product?.title,
                  landingPageId: props._id,
                  productId: product?._id,
                });
                setShowEditModal(true);
              }}
            >
              Edit Product
            </Button>
            {showEditModal && (
              <EditProductModal
                editData={editData}
                setShowEditModal={setShowEditModal}
                setProducts={setProducts}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Index;
